import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickerImageCard from '../../../common/MediaPickerImageCard';
import { MEDIA_SOURCE_TYPE, MEDIA_USAGE_TYPE } from '../../../../CreatePageConstants';
import { readBase64FromURL } from '../../../../../../../utilities/fileUtilities';
import { createActions } from '../../../../store';

const LogoStockImagesCard = (props) => {
    const { 
        galleryCardWidth, galleryCardHeight, logoStockImage, showImageCropper,
        savingInProgress, showCriticalOperationProgressWarning, isVideoExportsQueued
    } = props;

    const onImageClick = () => { 
        if (savingInProgress) {
            showCriticalOperationProgressWarning();
            return;
        }

        if (isVideoExportsQueued()) 
            return;
        
        readBase64FromURL(logoStockImage.originalUrl, (base64) => {
            showImageCropper(
                base64, 
                'png', 
                MEDIA_SOURCE_TYPE.STOCK_IMAGE, 
                MEDIA_USAGE_TYPE.LOGO,
                logoStockImage.id,
                logoStockImage.originalUrl
            );
        });
    };

    return (
        <MediaPickerImageCard 
            image={logoStockImage}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
            onImageClick={onImageClick}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const logoStockImage = state.mediaPicker.logoStockImages[ownProps.index];
    const { savingInProgress } = state.create.videoSavingState;
    return { logoStockImage, savingInProgress };
}

const mapDispatchToProps = (dispatch) => {
    const isVideoExportsQueued = () => dispatch(createActions.isVideoExportsQueued());
    const showImageCropper = (data, format, mediaSourceType, mediaUsageType, mediaResourceId, mediaResourceUrl) => dispatch(mediaPickerActions.showImageCropper(data, format, mediaSourceType, mediaUsageType, mediaResourceId, mediaResourceUrl));
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return { 
        showImageCropper,
        isVideoExportsQueued,
        showCriticalOperationProgressWarning 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoStockImagesCard);